export const smallSearchBreakpoint = 860;
export const dropdownMenuBreakpoint = 760;
